export default "__VITE_ASSET__CRgpa6jF__"